export const isFinalStatus = (status) => {
    return status === "accepted" || status === "rejected";
};

export const canVerify = ({
    userPosition,
    userDirectorate,
    status,
}) => {
    // block kalau sudah final
    if (isFinalStatus(status)) return false;

    // superadmin bebas
    if (userPosition === "superadmin" || userPosition === "Superadmin" || userPosition === "admin") return true;

    // hanya role tertentu + vokasi
    const allowedRoles = ["verifikator", "direktur"];

    return (
        allowedRoles.includes(userPosition) &&
        userDirectorate === "Direktorat Vokasi"
    );
};